import { useLang } from "../lib/i18n";

export const LangToggle = ({ className = "" }) => {
  const { lang, setLang } = useLang();
  return (
    <div className={`inline-flex rounded-full border border-slate-200 bg-white/80 p-1 backdrop-blur ${className}`} data-testid="language-toggle">
      {[["en", "EN"], ["ar", "عربي"]].map(([code, label]) => (
        <button
          key={code}
          type="button"
          onClick={() => setLang(code)}
          data-testid={`language-toggle-${code}`}
          className={`min-w-[52px] rounded-full px-3 py-1.5 text-sm font-semibold transition-colors duration-200 ${
            lang === code ? "bg-slate-900 text-white" : "text-slate-600 hover:text-slate-900"
          } ${code === "ar" ? "font-arabic" : ""}`}
        >
          {label}
        </button>
      ))}
    </div>
  );
};
